import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { environment as env } from '@env/environment';
import { EMPTY, Observable } from 'rxjs';
import { Comments } from '../modal/tasks';
import { FormGroup } from '@angular/forms';
import { SharedService } from 'app/shared/services/shared.service';
@Injectable({
  providedIn: 'root'
})
export class TasksWithoutProjectService {
  isEditing = new EventEmitter<boolean>();
  isEditing$ = this.isEditing.asObservable();

  constructor(
    private http: HttpClient,
    private _SharedService: SharedService
  ) { }


    // -------- Eng Ahmed Abdelhameed Ali --------
  getAllTasks(query: any): Observable<any> {
    const value: any = {};
    // debugger;
    for (const key in query) {
      if (query[key]) {
        value[key] = query[key];  // for no send null value
      }
    }
    return this.http.post(`${env.domain}Tasks/GetAllTasks`, value)
  }

  getAllTasksNoProjects(query: any): Observable<any> {
    const value: any = {};
    for (const key in query) {
      if (query[key]) {
        value[key] = query[key];
      }
    }
    return this.http.get(`${env.domain}Tasks/GetAllTasksThatHasNotProject`, { params: value })
  }
  addTask(body: any): Observable<any> {
    return this.http.post(`${env.domain}Tasks/AddTask`, this._SharedService.formateFormData(body))
  }
  AddTaskApproval(body: any): Observable<any> {
    return this.http.post(`${env.domain}Tasks/AddTaskApproval/${body['id']}`, body)

  }
  EditTask(body: any): Observable<any> {
    return this.http.put(`${env.domain}Tasks/EditTask/${body['Id']}`, this._SharedService.formateFormData(body))
  }
  getTaskById(TaskId: number): Observable<any> {
    return this.http.get(`${env.domain}Tasks/GetTaskById/${TaskId}`)
  }
  ChangeActiveOrNotTask(TaskId: number): Observable<any> {
    return this.http.put(`${env.domain}Tasks/ChangeActiveOrNotTask/${TaskId}`, {})
  }
  RemoveTask(TaskId: number): Observable<any> {
    return this.http.delete(`${env.domain}Tasks/RemoveTask/${TaskId}`)
  }
  ListOfPriorities(): Observable<any> {
    return this.http.get(`${env.domain}Tasks/ListOfPriorities`)
  }
  ListOfTasks(TaskId: number): Observable<any> {
    return this.http.get(`${env.domain}Tasks/ListOfTasks/${TaskId}`)
  }
  ListOfTaskStages(): Observable<any> {
    return this.http.get(`${env.domain}Tasks/ListOfTaskStages`)
  }
  ListOfEmployees(query: any): Observable<any> {
    const value: any = {};
    for (const key in query) {
      if (query[key]) {
        value[key] = query[key];
      }
    }
    return this.http.get(`${env.domain}Employees/ListOfEmployees`, { params: value })
  }
  EditTaskProgressing(body: any): Observable<any> {
    return this.http.put(`${env.domain}Tasks/EditTaskProgressing`, body)
  }
  GetAllTaskComments(value: any): Observable<any> {
    return this.http.get(`${env.domain}Tasks/GetAllTaskComments`, { params: this._SharedService.checkQuery(value) })
  }
  AddTaskComment(body: any) {
    return this.http.post(`${env.domain}Tasks/AddTaskComment`, this._SharedService.formateFormData(body))
  }
  AddMentionedEmployees(form: any = {}) {
    return this.http.post(`${env.domain}Tasks/AddMentionedEmployees`, form)
  }
  DeleteFileOrMoreOfTasks(listOfId: any[] = []): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(listOfId),
    };
    return this.http.delete<any>(`${env.domain}Tasks/DeleteFileOrMoreOfTask`, options)
  }
  RemoveTaskComment(id: number): Observable<any> {
    return this.http.delete<any>(`${env.domain}Tasks/RemoveTaskComment/${id}`)
  }
  GetAllTasksByCompanyOrDepartmentId(companyId: number): Observable<any> {
    return this.http.get(`${env.domain}Tasks/GetAllTasksByCompanyOrDepartmentId/${companyId}`)
  }
  GetDepartmentIdByProjectId(projectID: number): Observable<any> {
    return this.http.get(`${env.domain}Projects/GetDepartmentIdByProjectId/${projectID}`)
  }
}

